import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
import _extends from "/app/node_modules/babel-runtime/helpers/extends";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required } from "vuelidate/lib/validators";
import { mapMutations, mapState } from "vuex";
import { stepForm } from "~/mixins";
import { affiliationTypeEnum, currencyTypeEnum } from "~/enums";
import { ConflictError } from "~/abstractions/errors";
import { OnHoldError } from "~/api/errors";
import loader from "../modals/loader";
import PersonalDataTreatmentRadio from "./personal-data-treatment-radio";
import comisions from "../shared/table/comisions-table";
export default {
  mixins: [stepForm],
  components: {
    loader: loader,
    PersonalDataTreatmentRadio: PersonalDataTreatmentRadio,
    comisions: comisions
  },
  data: function data() {
    var authorizePersonalDataTreatment = this.$store.state.affiliations.form.afilliationSummary.authorizePersonalDataTreatment;

    return {
      loading: false,
      equipmentOptions: [{ value: "1", text: "1" }, { value: "2", text: "2" }, { value: "3", text: "3" }, { value: "4", text: "4" }, { value: "5", text: "5" }, { value: "6", text: "6" }, { value: "7", text: "7" }, { value: "8", text: "8" }, { value: "9", text: "9" }, { value: "10", text: "10" }],
      duesOptions: [{ value: "01", text: "1" }, { value: "03", text: "3" }],
      equipment: { value: "1", text: "1" },
      dues: { value: "01", text: "1" },
      currencyTypeEnum: currencyTypeEnum,
      authorizePersonalDataTreatment: authorizePersonalDataTreatment,
      dialog: false,
      tableComision: false,
      messageModal: 'Procesando Afiliación'
    };
  },

  validations: {
    authorizePersonalDataTreatment: { required: required }
  },
  computed: _extends({}, mapState({
    posSelected: function posSelected(state) {
      return state.affiliations.form.posSelected;
    },
    quotation: function quotation(state) {
      return state.affiliations.form.quotation;
    },
    commercialTariffResults: function commercialTariffResults(state) {
      return state.affiliations.form.commercialTariffResults;
    },
    osvType: function osvType(state) {
      return state.affiliations.form.osvType.osvType;
    },
    membershipType: function membershipType(state) {
      return state.affiliations.form.membershipType;
    },
    applyToPartnerPlan: function applyToPartnerPlan(state) {
      return state.affiliations.form.businessData.commerceData.applyToPartnerPlan;
    },
    modalityType: function modalityType(state) {
      return state.affiliations.form.modalityType;
    },
    multiAdress: function multiAdress(state) {
      return state.affiliations.form.multiAdress;
    }
  }), {
    isPosInalambrico: function isPosInalambrico() {
      return this.posName === this.$presentialPosEnum.POS_INALAMBRICO;
    },
    posName: function posName() {
      return this.posSelected.pos + ' ' + (this.modalityType.type === 1 ? 'Venta' : this.modalityType.type === 2 ? 'Alquiler' : 'Venta Extendida');
    },
    posNumber: function posNumber() {
      return this.quotation.posNumber || 1;
    },
    taxQuota: function taxQuota() {
      return this.quotation.taxQuota || "01";
    },
    calculateRentalSoles: function calculateRentalSoles() {
      return this.commercialTariffSoles.rental;
      // switch (this.osvType) {
      //   default:
      //   case 1:
      //     return this.quotation.rentalPrice.toFixed(2); // individual
      //   case 2:
      //     return (this.isPosInalambrico ? 30 : 15).toFixed(2); // multicomercio padre
      //   case 3:
      //     return (this.isPosInalambrico ? 30 : 15).toFixed(2); // registro codigo hijo
      // }
    },
    calculateRentalDolares: function calculateRentalDolares() {
      return this.commercialTariffDolares.rental;
      // switch (this.osvType) {
      //   default:
      //   case 1:
      //     return this.quotation.rentalPriceDolares.toFixed(2); // individual
      //   case 2:
      //     return (this.isPosInalambrico ? 10 : 5).toFixed(2); // multicomercio padre
      //   case 3:
      //     return (this.isPosInalambrico ? 10 : 5).toFixed(2); // registro codigo hijo
      // }
    },
    calculateShippingSoles: function calculateShippingSoles() {
      return this.quotation.stateShippingCost.toFixed(2);
    },
    calculateShippingDolares: function calculateShippingDolares() {
      return this.quotation.stateShippingCostDolar.toFixed(2);
    },

    // maintenancePriceCost() {
    //   return this.quotation.maintenancePriceCost && this.quotation.maintenancePriceCost.toFixed(2);
    // },
    // maintenancePriceCostDolar() {
    //   return this.quotation.maintenancePriceCostDolar && this.quotation.maintenancePriceCostDolar.toFixed(2);
    // },
    affiliationName: function affiliationName() {
      if (!this.membershipType) return;

      switch (this.membershipType.type) {
        case affiliationTypeEnum.PERMANENT:
          return "Permanente";
        case affiliationTypeEnum.TEMPORAL:
          return "Temporal";
        default:
          return "";
      }
    },
    commercialTariffSoles: function commercialTariffSoles() {
      return this.commercialTariffResults.find(function (c) {
        return c.currency === currencyTypeEnum.SOLES;
      }) || false;
    },
    commercialTariffDolares: function commercialTariffDolares() {
      return this.commercialTariffResults.find(function (c) {
        return c.currency === currencyTypeEnum.DOLARES;
      }) || false;
    },
    isSoles: function isSoles() {
      return !!this.commercialTariffSoles.currency;
    },
    isDolares: function isDolares() {
      return !!this.commercialTariffDolares.currency;
    },
    affiliation: function affiliation() {
      if (this.commercialTariffSoles) return this.commercialTariffSoles.tariff.affiliation;
      if (this.commercialTariffDolares) return this.commercialTariffDolares.tariff.affiliation;
      return "";
    },
    affiliationComment: function affiliationComment() {
      if (this.commercialTariffSoles) return this.commercialTariffSoles.tariff.affiliationComment;

      if (this.commercialTariffDolares) return this.commercialTariffDolares.tariff.affiliationComment;
      return "";
    },
    equipmentCost: function equipmentCost() {
      if (this.commercialTariffSoles) {
        return this.commercialTariffSoles.tariff.equipmentCost;
      }
      if (this.commercialTariffDolares) {
        return this.commercialTariffDolares.tariff.equipmentCost;
      }
      return "";
    },
    equipmentCostComment: function equipmentCostComment() {
      if (this.commercialTariffSoles) {
        return this.commercialTariffSoles.tariff.equipmentCostComment;
      }
      if (this.commercialTariffDolares) {
        return this.commercialTariffDolares.tariff.equipmentCostComment;
      }
      return "";
    },
    maintenance: function maintenance() {
      if (this.commercialTariffSoles) {
        return this.commercialTariffSoles.tariff.maintenance;
      }
      if (this.commercialTariffDolares) {
        return this.commercialTariffDolares.tariff.maintenance;
      }
      return "";
    },
    maintenanceDollar: function maintenanceDollar() {
      if (this.commercialTariffSoles) {
        return this.commercialTariffSoles.tariff.maintenanceDollar;
      }
      if (this.commercialTariffDolares) {
        return this.commercialTariffDolares.tariff.maintenanceDollar;
      }
      return "";
    },
    maintenanceComment: function maintenanceComment() {
      if (this.commercialTariffSoles) {
        return this.commercialTariffSoles.tariff.maintenanceComment;
      }
      if (this.commercialTariffDolares) {
        return this.commercialTariffDolares.tariff.maintenanceComment;
      }
      return "";
    },
    platformUsageCE: function platformUsageCE() {
      if (this.commercialTariffSoles) {
        return this.commercialTariffSoles.tariff.platformUsageCE;
      }
      if (this.commercialTariffDolares) {
        return this.commercialTariffDolares.tariff.platformUsageCE;
      }
      return "";
    },
    platformUsageCEComment: function platformUsageCEComment() {
      if (this.commercialTariffSoles) {
        return this.commercialTariffSoles.tariff.platformUsageCEComment;
      }
      if (this.commercialTariffDolares) {
        return this.commercialTariffDolares.tariff.platformUsageCEComment;
      }
      return "";
    },
    renewal: function renewal() {
      if (this.commercialTariffSoles) {
        return this.commercialTariffSoles.tariff.renewal;
      }
      if (this.commercialTariffDolares) {
        return this.commercialTariffDolares.tariff.renewal;
      }
      return "";
    },
    renewalComment: function renewalComment() {
      if (this.commercialTariffSoles) {
        return this.commercialTariffSoles.tariff.renewalComment;
      }
      if (this.commercialTariffDolares) {
        return this.commercialTariffDolares.tariff.renewalComment;
      }
      return "";
    },
    isRental: function isRental() {
      if (this.modalityType.type === 2) return true;
      return false;
    },
    isSale: function isSale() {
      if (this.modalityType.type === 1) return true;
      return false;
    },
    installationCostSoles: function installationCostSoles() {
      return this.commercialTariffSoles.installationCost * parseInt(this.equipment.value);
    },
    installationCostDolares: function installationCostDolares() {
      return this.commercialTariffDolares.installationCost * parseInt(this.equipment.value);
    },
    creditCommissionSoles: function creditCommissionSoles() {
      return this.commercialTariffSoles.creditCommission;
    },
    debitCommissionSoles: function debitCommissionSoles() {
      return this.commercialTariffSoles.debitCommission;
    },
    creditCommissionDolares: function creditCommissionDolares() {
      return this.commercialTariffDolares.creditCommission;
    },
    debitCommissionDolares: function debitCommissionDolares() {
      return this.commercialTariffDolares.debitCommission;
    },
    isApplyToPartnerPlan: function isApplyToPartnerPlan() {
      var apply = false;
      if (this.posSelected.id == 1 || this.posSelected.id == 2) {
        apply = this.applyToPartnerPlan;
      }

      return apply;
    }
  }),
  methods: {
    onSubmit: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var affiliation, equipmentCost, maintenance, installation, response, message, onHold;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.$v.$touch();
                if (this.multiAdress.length > 0) {
                  this.messageModal = 'Procesando Afiliaciones';
                }

                if (!(this.$v.invalid || this.loading)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:

                this.loading = true;
                this.$refs.loaderModal.showLoader();

                _context.prev = 6;
                affiliation = this.affiliation === 'No aplica' ? '' : this.affiliation;
                equipmentCost = this.equipmentCost === 'No aplica' ? '' : this.equipmentCost;
                maintenance = this.maintenance === 'No aplica' ? '' : this.maintenance;
                installation = affiliation || equipmentCost;
                _context.next = 13;
                return this.$store.dispatch("affiliations/form/saveAfilliationSummary", {
                  equipment: this.equipment,
                  dues: this.dues,
                  posName: this.posName,
                  posNumber: this.posNumber,
                  installationCost: this.isSoles ? installation : '',
                  installationCostDolar: this.isDolares ? installation : '',
                  authorizePersonalDataTreatment: this.authorizePersonalDataTreatment,
                  rentalSoles: this.isSoles ? maintenance : '',
                  rentalDolares: this.isDolares ? maintenance : ''
                });

              case 13:
                response = _context.sent;

                console.log('response summary: ', response);
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](6);

                if (_context.t0 instanceof ConflictError) {
                  try {
                    message = Array.isArray(_context.t0.message) ? _context.t0.message.map(function (m) {
                      return "c\xF3digo: " + m.codigo + " - descripci\xF3n: " + m.descripcion;
                    }).join(",") : _context.t0.message;
                    // console.log("message", message);

                    this.$swal("Ocurrió un error al guardar la afiliación", message, "warning");
                  } catch (error) {
                    // console.log("error", error);
                  }
                } else if (_context.t0 instanceof OnHoldError) {
                  this.$swal("La afiliaci\xF3n se encuentra en \"On Hold\" en estos momentos", "", "info");
                } else {
                  this.$controlMessage(_context.t0);
                }

              case 20:
                _context.prev = 20;

                this.loading = false;
                this.$refs.loaderModal.closeLoader();
                return _context.finish(20);

              case 24:
                onHold = this.$store.state.affiliations.form.onHold;

                if (!(this.multiAdress.length == 0)) {
                  _context.next = 37;
                  break;
                }

                if (onHold) {
                  _context.next = 35;
                  break;
                }

                _context.prev = 27;
                _context.next = 30;
                return this.$store.dispatch("affiliations/form/addCommerceCodeFile", {});

              case 30:
                _context.next = 35;
                break;

              case 32:
                _context.prev = 32;
                _context.t1 = _context["catch"](27);

                console.log('Error add commerceCode...', _context.t1);

              case 35:
                _context.next = 45;
                break;

              case 37:
                _context.prev = 37;
                _context.next = 40;
                return this.$store.dispatch("affiliations/form/addCommerceCodeFile", {});

              case 40:
                _context.next = 45;
                break;

              case 42:
                _context.prev = 42;
                _context.t2 = _context["catch"](37);

                console.log('Error add commerceCode...', _context.t2);

              case 45:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 17, 20, 24], [27, 32], [37, 42]]);
      }));

      function onSubmit() {
        return _ref.apply(this, arguments);
      }

      return onSubmit;
    }(),
    tableComissionClose: function tableComissionClose() {
      this.tableComision = false;
      this.dialog = false;
    }
  },
  mounted: function mounted() {}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/afilliation-summary.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/afilliation-summary.vue
// module chunks = 0 1 2 3